// RECORD TRANSFER API
// 病历转科
import Request from '../base'
export default {
  save (options) {
    return Request.post('/ebermain/mainapi/record/transfer/save', options)
  },
  listOrg (options) {
    return Request.post('/ebermain/mainapi/record/transfer/orgs', options)
  }
}
